import React from "react";
import { node } from "prop-types";
import Section from "../Section";
import { Col, Row } from "../Grid";
import ContentContainer from "../r1/atoms/ContentContainer";

const Head = ({ children }) => {
	return (
		<Row id="BlockQuoteHead">
			<Col>{children}</Col>
		</Row>
	);
};

Head.propTypes = {
	children: node.isRequired,
};
const Thumbs = ({ children }) => {
	return (
		<Row mx id="BlockQuoteThumbs" spacing={{ mb: 15 }}>
			{children}
		</Row>
	);
};

Thumbs.propTypes = {
	children: node.isRequired,
};

const Footer = ({ children }) => {
	return (
		<Row>
			<Col>{children}</Col>
		</Row>
	);
};

Footer.propTypes = {
	children: node.isRequired,
};

const BlockQuoteSlider = ({ children }) => {
	return (
		<Section spacing={{ pb: 20 }} className="bq">
			<ContentContainer lg={10} center>
				{children}
			</ContentContainer>
		</Section>
	);
};

BlockQuoteSlider.propTypes = {
	children: node.isRequired,
};

BlockQuoteSlider.Head = Head;
BlockQuoteSlider.Thumbs = Thumbs;
BlockQuoteSlider.Footer = Footer;

export default BlockQuoteSlider;
